import React, { useState } from 'react'
import { FaArrowLeft, FaArrowRight, FaStar } from 'react-icons/fa';

function Testimonials() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  
    const testimonials = [
      {
        id: 1,
        name: "Priya Sharma",
        age: 28,
        treatment: "Acne Treatment & Skin Rejuvenation",
        rating: 5,
        text: "After struggling with severe acne for years, DermaSlim Wellness gave me my confidence back. Dr. Pavani's personalized approach made me feel so comfortable.",
        image:
          "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=234&q=80",
        duration: "3 months treatment",
      },
      {
        id: 2,
        name: "Rahul Mehta",
        age: 35,
        treatment: "Hair Restoration Therapy",
        rating: 5,
        text: "Incredible results with my hair restoration journey! The team at DermaSlim is professional, caring, and truly knows their craft.",
        image:
          "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=234&q=80",
        duration: "6 months treatment",
      },
      {
        id: 3,
        name: "Anita Reddy",
        age: 42,
        treatment: "Anti-Aging & Wellness Program",
        rating: 5,
        text: "The holistic approach at DermaSlim is what sets them apart. They don't just treat the symptoms but address overall wellness.",
        image:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=234&q=80",
        duration: "4 months program",
      },
    ];
  
    const nextTestimonial = () => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    };
  
    const prevTestimonial = () => {
      setActiveTestimonial(
        (prev) => (prev - 1 + testimonials.length) % testimonials.length
      );
    };
  
    const renderStars = (rating) => {
      return Array.from({ length: 5 }, (_, index) => (
        <FaStar
          key={index}
          className={`text-sm ${
            index < rating ? "text-primary" : "text-gray-300"
          }`}
        />
      ));
    };
  
    const currentTestimonial = testimonials[activeTestimonial];
  

  return (
       <section className="py-16 bg-secondary">
           <div className="max-w-7xl mx-auto px-4 md:px-8">
             <div className="text-center mb-12">
               <h3 className="text-lg font-semibold text-primary mb-2">
                 Testimonials
               </h3>
               <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                 Hear From Our Happy Clients
               </h2>
               <p className="text-gray-600 max-w-2xl mx-auto">
                 Real stories from real people who transformed their lives with our
                 wellness programs.
               </p>
             </div>
   
             <div className="max-w-4xl mx-auto">
               <div className="bg-white rounded-lg p-6 shadow-sm border mb-8">
                 <div className="flex gap-1 mb-4">
                   {renderStars(currentTestimonial.rating)}
                 </div>
   
                 <blockquote className="text-gray-700 leading-relaxed mb-6">
                   "{currentTestimonial.text}"
                 </blockquote>
   
                 <div className="flex items-center gap-4">
                   <img
                     src={currentTestimonial.image}
                     alt={currentTestimonial.name}
                     className="w-12 h-12 rounded-full object-cover"
                   />
                   <div>
                     <h4 className="font-semibold text-gray-900">
                       {currentTestimonial.name}
                     </h4>
                     <p className="text-gray-600 text-sm">
                       {currentTestimonial.age} years •{" "}
                       {currentTestimonial.duration}
                     </p>
                     <p className="text-primary text-sm font-medium">
                       {currentTestimonial.treatment}
                     </p>
                   </div>
                 </div>
               </div>
   
               <div className="flex items-center justify-between">
                 <div className="flex gap-2">
                   {testimonials.map((_, index) => (
                     <button
                       key={index}
                       onClick={() => setActiveTestimonial(index)}
                       className={`w-2 h-2 rounded-full transition-colors ${
                         index === activeTestimonial ? "bg-primary" : "bg-gray-300"
                       }`}
                     />
                   ))}
                 </div>
   
                 <div className="flex gap-2">
                   <button
                     onClick={prevTestimonial}
                     className="p-2 bg-secondary rounded-lg hover:bg-secondary/80 transition-colors"
                   >
                     <FaArrowLeft className="text-sm text-primary" />
                   </button>
                   <button
                     onClick={nextTestimonial}
                     className="p-2 bg-secondary rounded-lg hover:bg-secondary/80 transition-colors"
                   >
                     <FaArrowRight className="text-sm text-primary" />
                   </button>
                 </div>
               </div>
   
               <div className="grid grid-cols-3 gap-4 mt-8">
                 <div className="bg-white rounded-lg p-4 text-center shadow-sm border">
                   <div className="text-lg font-bold text-primary">500+</div>
                   <div className="text-gray-600 text-sm">Happy Clients</div>
                 </div>
                 <div className="bg-white rounded-lg p-4 text-center shadow-sm border">
                   <div className="text-lg font-bold text-primary">4.9/5</div>
                   <div className="text-gray-600 text-sm">Average Rating</div>
                 </div>
                 <div className="bg-white rounded-lg p-4 text-center shadow-sm border">
                   <div className="text-lg font-bold text-primary">98%</div>
                   <div className="text-gray-600 text-sm">Success Rate</div>
                 </div>
               </div>
             </div>
           </div>
         </section>
  )
}

export default Testimonials